import { useSignal } from "@preact/signals-react";

import ButtonAction from "componentsv2/button/ButtonAction";

function GridWizard({ layout, wizards }) {
  const openModal = useSignal(false);
  console.log("wizards....", wizards);
  return (
    <div className="flex rounded-lg gap-x-2">
      {layout.wizards.map((wizard, idx) => (
        <ButtonAction
          key={idx}
          label={wizard.name}
          icon={wizard.icon}
          openModal={openModal}
          size={wizard.size}
        >
          <wizard.Component />
        </ButtonAction>
      ))}
    </div>
  );
}

export default GridWizard;
